import clsx from 'clsx'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import {
  clearRecentSearch,
  getRecentSearchItems,
} from 'components/search/utils'
import Typo from 'constants/typography'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { clearCta, searchSidebarTitle } from '../const'
import SearchSidebarItem from '../sidebar-item'

// TECH-20: recent searches only — the "Popular Search" placeholder list was
// removed. Renders nothing when there is no recent history.
const SearchSidebar = ({ t, setSearchWord }) => {
  const [, forceRerender] = useState(false)

  const updateKeyword = () => {
    clearRecentSearch()
    sessionStorage.removeItem('recent-search-word')
    setSearchWord('')
    forceRerender((value) => !value)
  }

  const recentSearchList = getRecentSearchItems()
  if (!recentSearchList?.length) {
    return null
  }

  const sidebarTitle = hasLocizeTranslation(
    t,
    searchSidebarTitle.recent.key,
    searchSidebarTitle.recent.value,
  )
  const clearCtaText = hasLocizeTranslation(t, clearCta.key, clearCta.value)

  return (
    <div className="search-sidebar__wrapper">
      <div className="search-sidebar__title__container">
        <div className={clsx('search-sidebar__title', Typo.subtitle2)}>
          {sidebarTitle}
        </div>
        <div className="clear-btn__container">
          <button
            className={clsx('clear-btn', Typo.overline, 'active')}
            onClick={updateKeyword}
          >
            {clearCtaText}
          </button>
        </div>
      </div>
      <SearchSidebarItem
        keywordList={recentSearchList}
        isRecentSearchValid
        setSearchWord={setSearchWord}
      />
    </div>
  )
}

SearchSidebar.propTypes = {
  setSearchWord: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(SearchSidebar)
